<template>
  <div class="keep-alive">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <!--不缓存的视图-->
    <router-view v-if="!$route.meta.keepAlive"></router-view>
    <template></template>
  </div>
</template>

<script>
import { config } from '@/common/js/config.js'
import { operationMixins } from '@/common/mixins/operation/operation.js'
export default {
  mixins: [operationMixins],
  data() {
    return {
      list: [
        {
          name: '申领流程',
          url: '/fire/fixedAssetsIndex/approvelIndex/approvelApplyIndex',
          keyword: 'ROLE_ApplyApproveSetting',
          parentUrl: '/fire/fixedAssetsIndex/approvelIndex'
        },
        {
          name: '移交流程',
          url: '/fire/fixedAssetsIndex/approvelIndex/approvelTransferIndex',
          keyword: 'ROLE_TransferApproveSetting',
          parentUrl: '/fire/fixedAssetsIndex/approvelIndex'
        },
        {
          name: '报废流程',
          url: '/fire/fixedAssetsIndex/approvelIndex/approvelScrapIndex',
          keyword: 'ROLE_AbandonedApproveSetting',
          parentUrl: '/fire/fixedAssetsIndex/approvelIndex'
        },
        {
          name: '盘亏流程',
          url: '/fire/fixedAssetsIndex/approvelIndex/approvelInventoryLossIndex',
          keyword: '',
          parentUrl: '/fire/fixedAssetsIndex/approvelIndex'
        },
        {
          name: '盘盈流程',
          url: '/fire/fixedAssetsIndex/approvelIndex/approvelInventoryGainIndex',
          keyword: '',
          parentUrl: '/fire/fixedAssetsIndex/approvelIndex'
        },
        {
          name: '调拨流程',
          url: '/fire/fixedAssetsIndex/approvelIndex/approvelAllocationIndex',
          keyword: '',
          parentUrl: '/fire/fixedAssetsIndex/approvelIndex'
        },
      ]
    }
  },
  mounted() {
    config()
    this.$nextTick(() => {
      this.$bus.emit('isShowTopMenu', true)
      this.$bus.emit('getTopMenuList', this.list)
    })
  }
};
</script>
<style lang='scss' scoped>
.keep-alive {
  flex: 1;
  display: flex;
  flex-direction: column;
}
</style>